import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import {
    checkRestrictionDetailPrivilege,
    fetchRestriction,
    RestrictionFormView,
} from '@mews-commander/modules/src/modules/restrictions';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Restriction/Detail/$restrictionId')({
    validateSearch: z.object({
        OwnerId: z.string().uuid(),
    }),
    loaderDeps: ({ search: { OwnerId } }) => ({ OwnerId }),
    loader: async ({
        params: { restrictionId },
        deps: { OwnerId },
        context: {
            getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: getState,
            dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: dispatch,
        },
    }) => {
        await fetchRestriction({ dispatch, getState, search: { OwnerId } }, { restrictionId });
        if (!checkRestrictionDetailPrivilege(getState(), { serviceId: OwnerId, restrictionId })) {
            throw notFound();
        }
    },
    component: Component,
    staticData: {
        title: TextKey.Restriction,
        routeName: RouteName.RestrictionDetail,
        owner: MewsTeam.Services,
        type: RouteType.Frontend,
        guideLink: createGuideLink(ArticlePath.ManagingRestrictions),
    },
});

function Component() {
    const { restrictionId } = Route.useParams();
    const { OwnerId: serviceId } = Route.useSearch();

    return <RestrictionFormView serviceId={serviceId} restrictionId={restrictionId} formType="editForm" />;
}
